import Phaser from 'phaser'

import TextureKeys from '../consts/TextureKeys'
import SceneKeys from '../consts/SceneKeys'
import AnimationKeys from '../consts/AnimationKeys'

export default class Preloader extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Preloader)
  }

  preload() {
    this.load.setBaseURL('/')

    this.load.image(TextureKeys.Background, 'house/bg_repeat_1648x720.png')
    this.load.image(TextureKeys.LaserEnd, 'house/object_laser_end.png')
    this.load.image(TextureKeys.LaserMiddle, 'house/object_laser.png')

    // Load coin sprite sheet atlas
    this.load.atlas(TextureKeys.CoinSheet, 'house/coins-spritesheet.png', 'house/coins-spritesheet.json')

    this.load.atlas(TextureKeys.RocketMouse, 'characters/rocket-mouse.png', 'characters/rocket-mouse.json')

    // Load throw item sprite sheet atlas
    this.load.atlas(TextureKeys.ThrowItem, 'characters/throw-item.png', 'characters/throw-item.json')

    // Load drone sprite sheet atlas
    this.load.atlas(TextureKeys.DroneSheet, 'drone/drone_sprite.png', 'drone/drone_sprite.json')

    // Load flags
    this.load.image(TextureKeys.PakistanFlag, 'flags/pakistan.png')
    this.load.image(TextureKeys.AfganiFlag, 'flags/afgani.png')
    this.load.image(TextureKeys.AlbaniaFlag, 'flags/albania.png')
    this.load.image(TextureKeys.RussiaFlag, 'flags/russia.png')
    this.load.image(TextureKeys.GayFlag, 'flags/gay.png')

    // Load British flag projectile
    this.load.image(TextureKeys.BritainFlag, 'flags/britain.png')

    // Load bomb
    this.load.image(TextureKeys.Bomb, 'weapons/bomb.png')

    // Load coin sound effect
    this.load.audio('coin-sound', 'sfx/coin.mp3')

    // Load background music
    this.load.audio('background-music', 'sfx/music.mp3')

    // Load flag throw sound effect
    this.load.audio('flag-throw', 'sfx/flag.mp3')

    // Load death sound effect
    this.load.audio('death-sound', 'sfx/death.mp3')

    // Load explosion sound effect
    this.load.audio('explosion-sound', 'sfx/explosion.mp3')
  }

  create() {
    this.scene.start(SceneKeys.StartScreen)
  }
}
